import crypto from 'crypto';

const ALGORITHM = 'aes-256-cbc';
const BLOCK_SIZE = 16;

export function aesDecrypt(cipherText, key) {
  if (!key) return cipherText;
  try {
    const contents = Buffer.from(cipherText, 'hex');
    const iv = contents.slice(0, BLOCK_SIZE);
    const textBytes = contents.slice(BLOCK_SIZE);

    const decipher = crypto.createDecipheriv(ALGORITHM, key, iv);
    let decrypted = decipher.update(textBytes, 'hex', 'utf8');
    decrypted += decipher.final('utf8');

    if (window.countryCode === 'RU') {
      decrypted = decrypted.replaceAll(
        'tonplace.ams3.cdn.digitaloceanspaces.com',
        'cdn2.ton.place',
      );
    }

    return decrypted;
  } catch (e) {
    return null;
  }
}
